module.exports = __webpack_public_path__ + "media/images/vp/dobro.logo-c6a1f8a92b30959a2404401ce7458c16.svg";